import { Suspense } from 'react';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { Skeleton } from '@sara/ui/components/skeleton';
import { WebhookListContainerContent } from './WebhookListContainerContent';
import type { WebhookListContainerProps } from './types';

export type { WebhookListContainerProps };

function WebhookListSkeleton() {
  return (
    <div className="space-y-4">
      <Skeleton className="h-3 w-32" />
      <div className="divide-y divide-border/70 border-y border-border/70">
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex items-center justify-between gap-5 py-5">
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-48" />
              <Skeleton className="h-3 w-72" />
              <Skeleton className="h-3 w-40" />
            </div>
            <Skeleton className="h-6 w-10 rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function WebhookListContainer(props: WebhookListContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<WebhookListSkeleton />}>
        <WebhookListContainerContent {...props} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
